import React from 'react';
import type {
  IStepTabConfig,
  TReportStepType,
} from '../../../components/ReportViewer/types';
import aiGalleryTabPreviewOn from '@/pages/aigc/assets/svg/ai-gallery-tab-preview-on.svg';
import aiGalleryTabPreviewOff from '@/pages/aigc/assets/svg/ai-gallery-tab-preview-off.svg';
import aiGalleryTabCodeOn from '@/pages/aigc/assets/svg/ai-gallery-tab-code-on.svg';
import aiGalleryTabCodeOff from '@/pages/aigc/assets/svg/ai-gallery-tab-code-off.svg';

/**
 * AI Gallery HTML 右侧面板步骤枚举（复用 DS 报告的 TReportStepType 取值空间）
 */
export const AI_GALLERY_STEP = {
  /** 渲染预览（iframe） */
  PREVIEW: 'framework' as TReportStepType,
  /** 源代码只读展示 */
  CODE: 'report' as TReportStepType,
};

/** Tab 图标映射 */
const GALLERY_TAB_ICONS = {
  [AI_GALLERY_STEP.PREVIEW]: { on: aiGalleryTabPreviewOn, off: aiGalleryTabPreviewOff },
  [AI_GALLERY_STEP.CODE]: { on: aiGalleryTabCodeOn, off: aiGalleryTabCodeOff },
};

/**
 * ReportStepTabs 使用的页签配置：预览 / 代码
 */
const AI_GALLERY_STEP_TABS_CONFIG: IStepTabConfig[] = [
  {
    label: '预览',
    labelEn: 'Preview',
    value: AI_GALLERY_STEP.PREVIEW,
  },
  {
    label: '代码',
    labelEn: 'Code',
    value: AI_GALLERY_STEP.CODE,
  },
];

/**
 * 根据当前激活的 step 生成带图标的 Tab 配置
 */
export const getGalleryStepTabsConfig = (
  stepActive: TReportStepType,
): IStepTabConfig[] =>
  AI_GALLERY_STEP_TABS_CONFIG.map((tab) => {
    const isActive = tab.value === stepActive;
    const icons = GALLERY_TAB_ICONS[tab.value];
    const iconSrc = icons ? (isActive ? icons.on : icons.off) : undefined;
    return {
      ...tab,
      showStepIndex: false,
      icon: iconSrc ? React.createElement('img', { src: iconSrc, alt: '', 'aria-hidden': true }) : undefined,
    };
  });
